module.exports = __webpack_public_path__ + "static/img/block2_2.f8bf3b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/parkDescription/block2_2.png
// module id = d6ys
// module chunks = 1